import { generateURL, trackError } from 'utils/helpers';

const checkout = {
  client_token: () => {
    const url = generateURL('/checkout/client_token');

    return fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then((response) => response.json());
  },

  checkout_booking: ({
    payment_data_nonce,
    uid,
    payment_type_id,
    reference,
    payBalance,
    amount_in_cents,
    subscribe_to_email_list,
    payment_method_token,
    voucher_payments,
  }) => {
    const url = generateURL('/checkout/create');
    return fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        payment_data_nonce,
        uid,
        payment_type_id,
        reference,
        balance: payBalance,
        amount_in_cents,
        subscribe_to_email_list,
        payment_method_token,
        voucher_payments,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.error !== undefined) {
          return Promise.reject(new Error(data.error));
        }
        return data;
      });
  },

  checkout_status: ({ checkout_id }) => {
    const url = generateURL(`/checkout/status/${checkout_id}`);
    return fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then((response) => response.json());
  },

  vault: () => {
    const url = generateURL(`/checkout/vault`);
    return fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((json) => json)
      .catch((error) => {
        trackError(error);

        return {
          message: error.message,
        };
      });
  },

  makeVaultDefault: (token) => {
    const url = generateURL(`/checkout/vault/${token}/make_default`);
    return fetch(url, {
      method: 'PUT',
    }).then((response) => {
      if (response.status > 299) {
        return Promise.reject(new Error('Failed to set card as default.'));
      }
      return response.json();
    });
  },

  deleteVault: (token) => {
    const url = generateURL(`/checkout/vault/${token}`);
    return fetch(url, {
      method: 'DELETE',
    })
      .then((response) => response.json())
      .catch((error) => {
        trackError(error);

        return {
          message: error.message,
        };
      });
  },

  checkVoucherBalance: (voucherCode) => {
    const url = generateURL(
      `/checkout/check_voucher_balance?short_code=${voucherCode}`
    );
    return fetch(url, {
      method: 'GET',
    }).then((response) => {
      if (response.status > 299) {
        const message = `Voucher code ${voucherCode} is invalid`;
        return Promise.reject(new Error(message));
      }
      return response.json();
    });
  },
};

export default checkout;
